import { FC } from 'react';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

type ConfirmDeactivateTeamMemberModalProps = {
  isOpen: boolean;
  setClosed: () => void;
  onConfirm: () => void;
  isDeactivating: boolean;
  isExternalCollaborator?: boolean;
};

const ConfirmDeactivateTeamMemberModal: FC<
  ConfirmDeactivateTeamMemberModalProps
> = ({
  isOpen,
  setClosed,
  onConfirm,
  isDeactivating,
  isExternalCollaborator = false,
}) => {
  return (
    <Modal isOpen={isOpen} setClosed={setClosed} width="small">
      <div className="px-10 py-8">
        <div className="flex flex-col items-center">
          <div className="mb-2 flex text-center font-serif text-subtitle-small text-green-150">
            Would you like to {isExternalCollaborator ? 'revoke' : 'suspend'}{' '}
            this {isExternalCollaborator ? 'collaborator' : 'team member'}?
          </div>
          <div className="text-center text-body text-green-125">
            {isExternalCollaborator
              ? 'Revoked collaborators will no longer be able to access your team or any client data. Any assigned clients will be unassigned.'
              : "Suspended team members will no longer be able to login to the Homecoming platform or access any of your or your client's data. Any assigned clients will be unassigned."}
          </div>
        </div>
        <div className="mt-11 flex w-full flex-row items-center justify-center">
          <Button
            title="Cancel"
            theme="secondary"
            className="mr-5"
            onClick={setClosed}
          />
          <Button
            title={isExternalCollaborator ? 'Revoke' : 'Suspend'}
            theme="primary"
            onClick={onConfirm}
            disabled={isDeactivating}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeactivateTeamMemberModal;
